{
  "information":[
        {
		    "category": "メディア向け",
        "date": "2026.04.27",
        "title": "オンライン完結 「みんなの銀行 法人口座」を提供開始｜最短翌営業日での口座開設、安心安全なパスキー認証",
        "url": "https://corporate.minna-no-ginko.com/information/corporate/2026/04/27/804/",
        "corporate": 1,
        "business": 1,
        "baas": 1
        }
]
}